import React from 'react';
import IconButtonBase from './IconButtonBase';
import { TIconButton } from './types';

const Destructive = ({ as = 'button', ...rest }: TIconButton) => (
  <IconButtonBase {...rest} as={as} kind="destructive" />
);

export default Destructive;
